import React from "react";
import {useDispatch, useSelector} from "react-redux";
import { setFilterValue } from "../../reducers/blueprint_images_reducer";
import "select2";
import I18n from "i18n-js";


function SortBlueprintImages(props) {
  const dispatch = useDispatch();

  const { sort_by, sorting_direction } = useSelector(state => state.filters )
  const sortingOptions = useSelector(state => state.sortingOptions )
  const sortingDirections = useSelector(state => state.sortingDirections )

  const handleChangeFilterValue = (e) => {
    dispatch(setFilterValue(e.target.id, e.target.value))
  }

  return (
    <div className="advanced-search-sorting-container bg-light card pt-4 border-solid">
      {
        sortingOptions !== undefined ?
          <React.Fragment>
            <div className="form-group d-flex justify-content-start align-items-center mb-2">
              <div className="ml-4">
                <label>Sort results by:</label>
              </div>
              <div className="ml-4">
                <select className={`form-control ${sort_by ? 'border-aiG-blue-imp' : ''}`}
                        name="sort_by" id="sort_by" value={sort_by}
                        onChange={ handleChangeFilterValue }>
                  {sortingOptions.map(option => {
                    return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                  })}
                </select>
              </div>
              <div className="ml-3"><b>:</b></div>
              <div className="ml-3">
                <select className={`form-control ${sorting_direction ? 'border-aiG-blue-imp' : ''}`}
                        name="sorting_direction" id="sorting_direction" value={sorting_direction}
                        onChange={ handleChangeFilterValue }>
                  {sortingDirections.map(direction => {
                    return <option value={direction.value} key={direction.value}>{I18n.t(direction.locale)}</option>
                  })}
                </select>
              </div>
            </div>
          </React.Fragment>
        :
          ""
        }
    </div>
  );
}



export default SortBlueprintImages